import { store } from "../../scripts/vue/config/store";

export const isCartOpen = (): boolean => {
  return store?.state?.cart.open;
};

export const formatVariant = (activeVariant: { [key: string]: any }) => ({
  ...activeVariant,
  name: activeVariant.name ?? activeVariant.title,
  price: !isNaN(activeVariant.price)
    ? (activeVariant.price / 100).toFixed(2)
    : activeVariant.price,
});

export const updateMaestroVariants = (
  node: HTMLElement,
  activeVariant: object | HTMLElement
) => {
  if (activeVariant instanceof HTMLElement) {
    Object.keys(activeVariant.dataset)
      .filter((k) => k.startsWith("mtrProductVariant"))
      .forEach((k) => {
        node.dataset[k] = activeVariant.dataset[k];
      });
  } else {
    Object.keys(node.dataset)
      .filter((k) => k.startsWith("mtrProductVariant"))
      .map((k) => ({
        attr: k,
        key: k.replace("mtrProductVariant", "").toLowerCase(),
      }))
      .forEach(({ attr, key }) => {
        node.dataset[attr] = activeVariant[key];
      });
  }
};

export const stringToHTML = function (str: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  return doc.body;
};
